<script setup>
import { DialogTitle as HeadlessDialogTitle } from "@headlessui/vue";
</script>

<template>
  <HeadlessDialogTitle as="h2" class="text-lg font-semibold leading-none tracking-tight">
    <slot />
  </HeadlessDialogTitle>
</template>
